<template>
  <FormTemplate
    class="form__wrapper"
    data-anim="fade"
    data-view="false"
  >
    <FormCore
      slot="core"
      data-theme="default"
      :slots="['row-1', 'row-2', 'row-3', 'row-4']"
    >
      <FormRow
        slot="row-1"
        :slots="['fname', 'lname']"
      >
        <FormInput
          id="form-input-fname"
          slot="fname"
          :type="form.fname.type"
          :params="form.fname"
        />

        <FormInput
          id="form-input-lname"
          slot="lname"
          :type="form.lname.type"
          :params="form.lname"
        />
      </FormRow>

      <FormRow
        slot="row-2"
        :slots="['email']"
      >
        <FormInput
          id="form-input-email"
          slot="email"
          :type="form.email.type"
          :params="form.email"
        />
      </FormRow>

      <FormRow
        slot="row-3"
        :slots="['message']"
      >
        <FormInput
          id="form-input-message"
          slot="message"
          :type="form.message.type"
          :params="form.message"
        />
      </FormRow>

      <FormRow
        slot="row-4"
        :slots="['privacy', 'submit']"
      >
        <FormInput
          id="form-input-privacy"
          slot="privacy"
          :type="form.privacy.type"
          :params="form.privacy"
        />

        <FormInput
          id="form-input-submit"
          slot="submit"
          :type="form.submit.type"
          :params="form.submit"
        />
      </FormRow>
    </FormCore>
  </FormTemplate>
</template>

<script>
import FormTemplate from './Form/index.vue';
import FormCore from './Form/FormCore/index.vue';
import FormRow from './Form/FormExtra/FormRow.vue';
import FormInput from './Form/FormInput/index.vue';

export default {
  name: 'Form',

  components: {
    FormTemplate,
    FormCore,
    FormRow,
    FormInput,
  },

  data() {
    return {
      form: {
        fname: {
          id: 'fname',
          name: 'fname',
          type: 'text',
          label: 'Name',
          autocomplete: 'given-name',
          size: 50,
          required: true,
        },
        lname: {
          id: 'lname',
          name: 'lname',
          type: 'text',
          label: 'Surname',
          autocomplete: 'family-name',
          size: 50,
          required: true,
        },
        email: {
          id: 'email',
          name: 'email',
          type: 'email',
          label: 'Email',
          autocomplete: 'email',
          size: 100,
          required: true,
        },
        message: {
          id: 'message',
          name: 'message',
          type: 'textarea',
          label: 'Message',
          cols: 30,
          rows: 4,
          size: 100,
          required: true,
        },
        privacy: {
          id: 'privacy',
          name: 'privacy',
          type: 'checkbox',
          choices: [{
            id: 'privacy',
            value: 'privacy',
            label: 'Accept <a target="_blank" rel="noopener noreferrer" href="https://www.iubenda.com/privacy-policy/18990984"><strong>Privacy</strong></a>',
          }],
          required: true,
        },
        submit: {
          id: 'submit',
          name: 'submit',
          type: 'submit',
          text: 'Send request',
          sending: 'SENDING',
          sent: 'SENT',
        },
      },
    };
  },
};
</script>

<style lang="scss">
input, textarea, select {
  font-family: $font-family-base;
}

a strong {
  font-weight: 600;
}
</style>
